import { formatPercent } from '@talos/kyoko';

import { InspectorNumberDisplay } from './InspectorNumberDisplay';

interface InspectorPercentDisplayProps {
  value?: string;
  decimalPlaces?: number;
}

export const InspectorPercentDisplay = ({ value, decimalPlaces = 2 }: InspectorPercentDisplayProps) => {
  const percentValue = formatPercent(value, decimalPlaces);

  return (
    <InspectorNumberDisplay
      value={percentValue ?? ''}
      currency="%"
      increment={`0.${'0'.repeat(decimalPlaces - 1)}1`}
      trimTrailingZeroes
      showDashIfEmpty
    />
  );
};
